<template>
  <div class="tinymce-boxz">
    <Editor v-model="content" :api-key="apiKey" :init="init" />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { reactive, ref, toRefs } from '@vue/reactivity'
import { watch, getCurrentInstance } from 'vue'
export default {
  props: ['content_s', 'placeholder'],
  components: {
    Editor
  },
  emit: ['sendMsg'],
  setup(props, { emit }) {
    let { proxy: _this } = getCurrentInstance()
    let content = ref('')
    watch(
      () => props.content_s,
      () => {
        // console.log(props.content_s)
        content.value = props.content_s
        if (props.content_s && !props.placeholder) {
          content.value = ''
        }
      }
    )
    const tiny = reactive({
      apiKey: 'nxu2vhhei9rzpoywunelqzese7oujxgb5gm9oym7stwzr0sh', //https://github.com/tinymce/tinymce-vue/blob/main/src/demo/views/Iframe.vue
      init: {
        language: 'zh_CN', //语言类型
        placeholder: '在这里输入文字', //textarea中的提示信息
        min_width: 320,
        min_height: 220,
        height: 500, //注：引入autoresize插件时，此属性失效
        resize: false, //编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号
        branding: false, //tiny技术支持信息是否显示
        statusbar: false, //最下方的元素路径和字数统计那一栏是否显示
        // elementpath: false, //元素路径是否显示

        font_formats:
          '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;', //字体样式
        plugins: 'link lists image code table   wordcount ', //插件配置 axupimgs indent2em
        toolbar:
          'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat', //工具栏配置，设为false则隐藏
        menubar: 'file edit insert  format table', //菜单栏配置，设为false则隐藏，不配置则默认显示全部菜单，也可自定义配置--查看 http://tinymce.ax-z.cn/configure/editor-appearance.php --搜索“自定义菜单”

        images_upload_url: '/apib/api-upload/uploadimg', //后端处理程序的url，建议直接自定义上传函数image_upload_handler，这个就可以不用了
        // images_upload_base_path: '/demo',  //相对基本路径--关于图片上传建议查看--http://tinymce.ax-z.cn/general/upload-images.php
        paste_data_images: true, //图片是否可粘贴
        //此处为图片上传处理函数
        images_upload_handler: async (blobInfo, success, failFun) => {
          // 这里用base64的图片形式上传图片,
          if (!props.placeholder) {
            let reader = new FileReader() //本地预览
            reader.readAsDataURL(blobInfo.blob())
            reader.onloadend = function () {
              const imgbase64 = reader.result
              success(imgbase64)
            }
          } else {
            var file = blobInfo.blob() //转化为易于理解的file对象
            // xhr = new XMLHttpRequest()
            // xhr.withCredentials = false
            var formData = new FormData()
            formData.append('img', file) //此处与源文档不一样
            let res = await _this.$http.post(
              `/auth/user/upload_lottery_img`,
              formData
            )
            // console.log(res)
            if (res.data.code === 200) {
              console.log(props.content_s, 5555)
              emit('sendMsg', `<img src='${res?.data.data.img_path}'/>`)
              failFun('Invalid JSON: ' + '上传成功')
            } else {
              failFun('Invalid JSON: ' + '上传失败')
            }

            // xhr.open(
            //   'POST',
            //   'http://api.deyity.com/v2/auth/user/upload_lottery_img'
            // )
            // xhr.onload = function () {
            //   var json
            //   if (xhr.status != 200) {
            //     failFun('HTTP Error: ' + xhr.status)
            //     return
            //   }
            //   json = JSON.parse(xhr.responseText)
            //   if (!json || typeof json.location != 'string') {
            //     // content.value += `<img src='${json?.data.img_path}'/>`
            //     emit('sendMsg', `<img src='${json?.data.img_path}'/>`)
            //     failFun('Invalid JSON: ' + '上传成功')
            //     return
            //   }
            //   success(json.location)
            // }
            // xhr.send(formData)
          }
        }
      }
    })
    // tiny.init.placeholder = props.placeholder ?? ''
    // content.value = props.placeholder ?? ''

    return {
      content,
      ...toRefs(tiny)
    }
  }
}
</script>
<style scoped>
.tinymce-boxz > textarea {
  display: none;
}
</style>
<style>
/* 隐藏apikey没有绑定当前域名的提示 */
.tox-notifications-container .tox-notification--warning {
  display: none !important;
}

.tox.tox-tinymce {
  max-width: 100%;
}
</style>
